import { useState } from 'react';
import { Button, MenuItem, Modal } from 'react-bootstrap';
import { ConfirmActions } from './confirm-actions';

interface IProps {
    name: string,
    action: ConfirmActions,
    onConfirm: () => void | Promise<void>
}

export default function ConfirmAction({ name, action, onConfirm }: IProps) {
    const [show, setShow] = useState(false);

    const getTitle = () => {
        if (action == ConfirmActions.ResendInvitationEmail) {
            return 'Resend Invitation Email';
        }
        if (action == ConfirmActions.SendDashboardLink) {
            return 'Send Dashboard Link Email';
        }
    }

    const getContent = () => {
        if (action == ConfirmActions.ResendInvitationEmail) {
            return 'Please confirm that you would like to resend the invitation email to the following microsite holder:';
        }
        if (action == ConfirmActions.SendDashboardLink) {
            return 'Please confirm that you would like to send the dashboard link to the following microsite holder:';
        }
    }

    const handleConfirm = async () => {
        await onConfirm();
        setShow(false);
    };

    return (
        <>
            <MenuItem onClick={() => setShow(true)}>{getTitle()}</MenuItem>

            <Modal bsSize='sm' show={show} backdrop='static' onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    {getTitle()}
                </Modal.Header>
                <Modal.Body>
                    <div className='text-center' style={{ marginBottom: 10 }}>
                        {getContent()}
                    </div>
                    <div className='text-center'>
                        <strong>{name}</strong>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={handleConfirm}>Confirm</Button>
                    <Button onClick={() => setShow(false)}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
